import type { TokenPricesResponse } from 'api/DynaVaultsAPI';
import type { StakingPool } from 'api/StakingAPI';
import {
  migrationTokens,
  stakingTokens,
} from 'structure/capital-manager/tokens';

const stakingPriceTokens = [...stakingTokens, ...migrationTokens];

const getTokenKey = (chainId: number, address: string) =>
  `${chainId}:${address.toLowerCase()}`;

const coingeckoIdsByToken = new Map(
  stakingPriceTokens.map((token) => [
    getTokenKey(token.chainId, token.address),
    token.coingeckoId,
  ])
);

export const getStakingTokenCoingeckoId = (
  chainId: number,
  address: string
) => coingeckoIdsByToken.get(getTokenKey(chainId, address));

export const getStakingTokenPrice = (
  prices: TokenPricesResponse | undefined,
  chainId: number,
  address: string
) => {
  const coingeckoId = getStakingTokenCoingeckoId(Number(chainId), address);
  return coingeckoId ? prices?.prices[coingeckoId] || 0 : 0;
};

export const getStakingPoolTokenPrice = (
  prices: TokenPricesResponse | undefined,
  pool: Pick<StakingPool, 'chainId' | 'depositTokenAddress'>
) =>
  getStakingTokenPrice(
    prices,
    Number(pool.chainId),
    pool.depositTokenAddress
  );
